// extracted by mini-css-extract-plugin
export default {"text":"Paragraph_text__xAcrK"};